import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import cookie from "js-cookie";
import vailcode from "@utils/errcode";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      modifyData: {},
      isUploading: false,
      isSubmit: false,
      selectTab: 0
    };
  },
  watch: {
    "$parent.popEventsShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.modifyData = Object.assign({
            start_time_format: '',
            end_time_format: ""
          }, this.$parent.modifyData);
          this.modifyData.start_time_format = this.cutStr(this.modifyData.start_time);
          this.modifyData.end_time_format = this.cutStr(this.modifyData.end_time);
          this.modifyData.multiplierInfo = typeof this.modifyData.multiplierInfo == 'string' ? JSON.parse(this.modifyData.multiplierInfo) : this.modifyData.multiplierInfo;
          this.modifyData.partnerInfo = typeof this.modifyData.partnerInfo == 'string' ? JSON.parse(this.modifyData.partnerInfo) : this.modifyData.partnerInfo;
        } else {
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onFileChange(field, e) {
      const formData = new FormData();
      formData.append('file', e.target.files[0]);
      if (!e.target.files[0].type.startsWith('image/')) {
        this.$refs[`fileInput_${field}`].value = '';
        this.$toasted.error('请选择图片');
        return false;
      }
      if (this.isUploading) return;
      this.isUploading = true;
      let token = cookie.get('token') || '';
      formData.append('_token', token);
      // 使用axios上传文件
      axios.post(`${loadConfig.http_host}/upload?_token=${token}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        let rs = response.data;
        if (rs.code == 0) {
          if (field == 'partnerInfo_icon') {
            this.modifyData.partnerInfo.icon = rs.data.url;
            this.$set(this.modifyData.partnerInfo, `icon`, rs.data.url);
          } else {
            this.modifyData[field] = rs.data.url;
            this.$set(this.modifyData, `${field}`, rs.data.url);
          }
        } else {
          this.$toasted.error(rs.message);
        }
        this.isUploading = false;
        this.$refs[`fileInput_${field}`].value = '';
      }).catch(error => {
        console.error(error);
        this.isUploading = false;
        this.$refs[`fileInput_${field}`].value = '';
      });
    },
    changeTime(field, v) {
      console.log(field, v);
      this.modifyData[field] = v;
      this.$set(this.modifyData, field, v);
    },
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      this.modifyData.start_time = this.modifyData.start_time_format;
      this.modifyData.end_time = this.modifyData.end_time_format;
      let rs = await this.$http.post("/events/modify", this.modifyData);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.getData();
        this.$parent.popEventsShow = false;
      });
    }
  }
};